import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Container,
  Button,
  CircularProgress,
  Fade,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { unsubscribeNewsletter } from "../../services/ContactUs";
import { ArrowBack } from "@mui/icons-material";

const UnSubscribeNewsletter = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const token = queryParams.get("token");

  const [loading, setLoading] = useState(!!token);
  const [statusCode, setStatusCode] = useState(null);

  useEffect(() => {
    if (!token) {
      setStatusCode(4); // Token Missing
      setLoading(false);
      return;
    }

    const unsubscribe = async () => {
      try {
        const result = await unsubscribeNewsletter(token);
        setStatusCode(result.code);
      } catch (error) {
        console.error("Failed to unsubscribe:", error);
        setStatusCode(5); // Something went wrong
      } finally {
        setLoading(false);
      }
    };
    unsubscribe();
  }, [token]);

  // Decide UI based on statusCode
  let statusColor = "text.primary";
  let title = "Unsubscribe";
  let displayMessage = "We could not verify your unsubscribe request.";
  let Icon = ErrorOutlineIcon;

  if (statusCode === 1) {
    statusColor = "success.main";
    title = "Unsubscribed Successfully";
    displayMessage = "You have been successfully unsubscribed from our newsletter.";
    Icon = CheckCircleIcon;
  } else if (statusCode === 2) {
    statusColor = "warning.main";
    title = "Already Unsubscribed";
    displayMessage = "You were already unsubscribed from our newsletter.";
    Icon = WarningAmberIcon;
  } else if (statusCode === 3) {
    statusColor = "error.main";
    title = "Email Not Found";
    displayMessage = "The email address was not found in our subscription list.";
    Icon = ErrorOutlineIcon;
  } else if (statusCode === 4) {
    statusColor = "error.main";
    title = "Data does not exist";
    displayMessage = "The unsubscribe link is invalid or has expired.";
    Icon = ErrorOutlineIcon;
  } else if (statusCode === 5) {
    statusColor = "error.main";
    title = "Something went wrong";
    displayMessage = "An error occurred while processing your request. Please try again later.";
    Icon = ErrorOutlineIcon;
  }

  return (


    <Box mt={8} display="flex" justifyContent="center" alignItems="center">
      {loading ? (
        <CircularProgress />
      ) : (
        <Fade in={true} timeout={800}>
          <Container
            maxWidth="sm"
            sx={{
              p: 2,
              gap: 2,
              display: "flex",
              flexDirection: "column",
              borderRadius: 2,
              backgroundColor: "background.paper",
            }}
          >

            <Box
              sx={{
                bgcolor: "background.default",
                borderRadius: 50,
                p: 2,
                width: 80,
                height: 80,
              }}
            >
              <Box
                component="img"
                src="/assets/unsubscribed.png"
                alt="unsubscribe"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom fontWeight="bold" >
                {title}
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: statusColor }}>
                {displayMessage}
              </Typography>
              <Button
                variant="text"
                href="/"
                sx={{ textTransform: "none" }}
                disableElevation
                startIcon={<ArrowBack />}
              >
                Go to Home
              </Button>
            </Box>
          </Container>
        </Fade>
      )}
    </Box>

  );
};

export default UnSubscribeNewsletter;
